import { CalendarSvg } from '../svg/calendar.svg';
import { IconPropsDeprecated } from '@umanforge/common';

export const CalendarIcon = ( { className = 'w-5 h-5 text-blue-600', size, onClick }: IconPropsDeprecated ) => {
  return (
    <CalendarSvg
      className={ className }
      size={ size }
      onClick={ onClick }
    />
  );
};
